module.exports = __WEBPACK_EXTERNAL_MODULE__640__;